export default {
  methods: {
    /**
     * Скрывает модальное окно.
     *
     * @param {String} modalId
     */
    hideModal (modalId) {
      $(`#${modalId}`).modal('hide')
    },
    /**
     * Показывает модальное окно.
     *
     * @param {String} modalId
     */
    showModal (modalId) {
      $(`#${modalId}`).modal('show')
    }
  }
}
